// This is generated.  Alter it in blockGroups/listColumns/types/Link.js
/* eslint-disable no-unused-vars */
const { Type } = require('@sinclair/typebox');
const { moduleRegistration } = require('@sstdev/lib_metadata-config');
module.exports = {
  asDataDictionary: function asDataDictionary(hNode, context) {
    const { propertyName, propertyUrl } = hNode;

    // Create TypeBox string schema for the title property
    const titleSchema = Type.Optional(
      Type.String({
        title: 'Filename',
        'x-dataType': 'string',
        'x-propertyName': propertyName,
        'x-optional': true,
        'x-required': false,
      }),
    );

    // Create TypeBox string schema for the URL property
    const urlSchema = Type.Optional(
      Type.String({
        title: 'URL',
        'x-dataType': 'string',
        'x-propertyName': propertyUrl,
        'x-optional': true,
        'x-required': false,
      }),
    );

    //we know this data type (whatever it is), has at least these 2 properties
    const partialTypeDefinition = {
      [propertyName]: titleSchema,
      [propertyUrl]: urlSchema,
    };

    //And the given foreignKey exists on the parent object.
    return [{}, partialTypeDefinition];
  },
};
moduleRegistration.registerHNodeType('listColumns', 'Link', module.exports);
